var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1698 7.20034C15.1698 -0.95907 2.83236 -1.17379 2.83236 7.20034M2.83236 7.20034H3.68322V13.1051M2.83236 7.20034C2.17646 7.4662 0.893148 8.45808 1.00712 10.2988C1.12108 12.1394 2.83867 12.9366 3.68322 13.1051M3.68322 13.1051C3.68322 15.8965 5.73679 17 8.25659 17V15.8965M15.1676 7.20033H14.3168V13.1051C15.1613 12.9366 16.8789 12.1394 16.9929 10.2988C17.1069 8.45807 15.8235 7.46618 15.1676 7.20033Z",
    stroke: "#3F8CFF",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.a2aa1da99691a57e2b03b6b0d7feaa8f.svg";
export { ForwardRef as ReactComponent };